/* projects/speaker-platform/src/app/pages/texts-to-record/texts-to-record.component.scss */
.textstorecord__pdf {
  position: relative;
  width: 100%;
  padding: 32px;
}
.textstorecord__pdf__item {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, max-content);
  grid-row-gap: 30px;
  margin-bottom: 30px;
}
.textstorecord__pdf__reference,
.textstorecord__pdf__phasevocale {
  background-color: #FFED00;
}
.textstorecord__pdf__reference {
  grid-area: 1/1/2/2;
}
.textstorecord__pdf__phasevocale {
  grid-area: 1/2/2/3;
}
.textstorecord__pdf__texte {
  grid-area: 2/1/3/3;
  border-bottom: 2px solid;
  padding-bottom: 30px;
}
.textstorecord__pdf__phonetique {
  grid-area: 3/1/4/2;
}
.textstorecord__pdf__consigne {
  grid-area: 3/2/4/3;
}
.textstorecord__loader {
  padding: 32px 0;
  transform: scale(3);
  text-align: center;
}
.textstorecord__readermode {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr max-content max-content;
  column-gap: 40px;
  row-gap: 16px;
  padding: 32px 12px;
}
.textstorecord__readermode__text {
  grid-area: 1/1/3/3;
  font-size: 22px;
  line-height: 34px;
}
.textstorecord__readermode__phonetic {
  grid-area: 1/3/2/4;
}
.textstorecord__readermode__order {
  grid-area: 2/3/3/4;
}
.textstorecord__readermode__actions {
  grid-area: 3/1/4/4;
}
.textstorecord__readermode__provisoire {
  grid-area: 1/4/1/4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textstorecord__readermode__nophonetic {
  font-style: italic;
}
.textstorecord__standbyalert {
  margin-left: 8px;
  font-size: 14px;
  color: #952626;
}
/*# sourceMappingURL=texts-to-record.component-YGYK2HIC.css.map */
